/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, computed, createVNode, Fragment } from 'vue';
import props from './props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { useChildSlots } from '../hooks/slot.mjs';
import { i as isNumber_1 } from '../_chunks/dep-961339ce.mjs';
import { i as isString_1 } from '../_chunks/dep-7f2f03b4.mjs';
import { i as isArray_1 } from '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Space = defineComponent({
  name: "TSpace",
  props: _objectSpread({}, props),
  setup: function setup(props2) {
    var COMPONENT_NAME = usePrefixClass("space");
    var renderTNodeJSX = useTNodeJSX();
    var getChildSlots = useChildSlots();
    var renderStyle = computed(function () {
      var sizeMap = {
        small: "8px",
        medium: "16px",
        large: "24px"
      };
      var renderGap = "";
      if (isArray_1(props2.size)) {
        renderGap = props2.size.map(function (s) {
          if (isNumber_1(s)) return "".concat(s, "px");
          if (isString_1(s)) return sizeMap[s] || s;
          return s;
        }).join(" ");
      } else if (isString_1(props2.size)) {
        renderGap = sizeMap[props2.size] || props2.size;
      } else if (isNumber_1(props2.size)) {
        renderGap = "".concat(props2.size, "px");
      }
      return _objectSpread({
        gap: renderGap
      }, props2.breakLine ? {
        "flex-wrap": "wrap"
      } : {});
    });
    function renderChildren() {
      var children = getChildSlots();
      var separatorContent = renderTNodeJSX("separator");
      return children.map(function (child, index) {
        var showSeparator = index + 1 !== children.length && separatorContent;
        return createVNode(Fragment, null, [createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "-item")
        }, [child]), showSeparator && createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "-item-separator")
        }, [separatorContent])]);
      });
    }
    return function () {
      var _ref;
      var spaceClassNames = ["".concat(COMPONENT_NAME.value), (_ref = {}, _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "-align-").concat(props2.align), props2.align), _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "-").concat(props2.direction), props2.direction), _ref)];
      return createVNode("div", {
        "class": spaceClassNames,
        "style": renderStyle.value
      }, [renderChildren()]);
    };
  }
});

export { _Space as default };
//# sourceMappingURL=space.mjs.map
